import { render } from "./OrientationToggle.vue?vue&type=template&id=f4b7e23e&scoped=true"
import script from "./OrientationToggle.vue?vue&type=script&lang=js"
export * from "./OrientationToggle.vue?vue&type=script&lang=js"

import "./OrientationToggle.vue?vue&type=style&index=0&id=f4b7e23e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4b7e23e"]])

export default __exports__